module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-57.f89e7c4d.svg";